import { render, staticRenderFns } from "./EchartsBarChart.vue?vue&type=template&id=0ff9e709&scoped=true"
import script from "./EchartsBarChart.vue?vue&type=script&lang=js"
export * from "./EchartsBarChart.vue?vue&type=script&lang=js"
import style0 from "./EchartsBarChart.vue?vue&type=style&index=0&id=0ff9e709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9e709",
  null
  
)

export default component.exports